import { useLocation } from 'react-router-dom';

// Base path for game links (/games2/... is the old redesign preview address and redirects)
export const useGamesBase = () => (useLocation().pathname.startsWith('/games2') ? '/games2' : '/games');
